const mText =/*`e9e8e7
f2e2e2
ffdada
ffd3d2
cacaca
d7c6c6
ecc0bf
fdb9b9
ffb1b3
ffa9ad
b5b6b5
bfabab
d0a5a5
e09ea0
f0979a
fe8f95
ff858f
ff7b8a
ff6e85
a3a2a2
a59090
b68a8b
c68486
d37d81
e1757c
ee6b77
f96174
ff526f
ff406c
888987
8b7677
9c7072
ab696d
b86168
c55864
d24c60
dc405d
e82d5a
6b6c6b
735b5d
825558
904e54
9c4551
a83b4d
b32d4a
be1547
525251
5b4244
6a3b40
75333d
82283a
8d1737
3b3a3a
422c30
4d252f
571d2e
620e2e
222221
2d161e
360e1f
3e0020
e9e8e7
f4e2df
ffdad5
ffd3cb
cacaca
d8c6c4
edc0bb
feb9b3
ffb1aa
ffa9a1
b5b6b5
c0aba9
d1a5a1
e29e99
f19792
ff8f8a
ff8682
ff7c7a
a3a2a2
a6908f
b78a87
c7847f
d47d79
e27571
ef6b6a
fb6163
ff545c
ff4455
888987
8c7675
9d706d
ac6966
b9615f
c65857
d34d51
dd414b
e82f44
f4083d
6b6c6b
745b5a
835553
914e4d
9d4646
a83c40
b3303a
be1a34
525251
5c4242
6a3b3c
763436
822930
8d192b
3b3a3a
422c2e
4e252b
581d28
630e26
222221
2d161b
370e1b
e9e8e7
f5e1dd
ffdacf
ffd3c2
cacaca
d9c6c2
efbfb6
ffb9ab
ffb29e
ffaa92
b5b6b5
c1aba7
d3a59c
e29f92
f39887
ff917c
ff8870
ff7f64
ff7457
a3a2a2
a7908c
b88a82
c78479
d57d6f
e37564
ef6d59
fa644d
ff5841
ff4b33
888987
8c7673
9d7069
ac695f
ba6255
c6594b
d24f40
dc4436
e7352a
f0201e
6b6c6b
745b59
845550
914e47
9d463d
a83e35
b2322b
bc2221
525251
5c4240
6a3c37
763530
812b27
8c1d1e
3b3a3a
422c2c
4e2527
581e22
63101d
222221
2e1619
380e17
e9e8e7
f5e1db
ffdac9
ffd4b9
cacaca
dac6c0
efc0b0
ffbaa1
ffb392
ffad83
b5b6b5
c1aba4
d3a597
e3a089
f2997b
fe936d
ff8c5b
ff8449
ff7c31
a3a2a2
a7908a
b88b7c
c78570
d47f63
e17853
ec7143
f7692f
ff6114
888987
8d7670
9d7063
ac6a56
b96449
c45c39
cf5428
d74d12
6b6c6b
745c56
84564a
90503f
9c4932
a64124
af3812
525251
5b433e
693d34
753629
802d1e
892211
3b3a3a
422c2a
4e2622
581f1a
621312
222221
2e1617
380e12
e9e8e7
f7e1d7
ffdbc2
ffd6af
cacaca
dbc6bd
efc1aa
febc99
ffb687
ffb174
ffab5f
b5b6b5
c1aba1
d2a691
e1a180
ef9c70
fa965f
ff9148
ff8b2c
a3a2a2
a89086
b78c78
c58668
d28158
dd7c45
e6762f
ee710a
888987
8d766d
9c715f
aa6c4f
b6663d
bf612a
c75c0f
6b6c6b
745c53
825745
8e5237
984c26
a0470f
525251
5b433b
673e2f
723820
7b320e
3b3a3a
412d27
4d271d
572111
222221
2d1714
380f0a
410302
e9e8e7
f7e2d2
ffddbb
ffd9a7
cacaca
dbc6b8
ecc2a4
fabe91
ffba7b
ffb666
ffb24d
ffae2b
b5b6b5
c1ab9e
d0a78b
dea378
e99f65
f39b4f
fd9734
a3a2a2
a79183
b58d72
c2895f
cd844b
d68035
dd7d15
888987
8c776a
9a7359
a66e46
b06a32
b86619
6b6c6b
735d50
805840
8a542f
92501b
525251
594439
65402a
6e3b19
3b3a3a
402d25
4b2917
542401
222221
2c1810
e9e8e7
f6e2ce
ffdfb6
ffdc9f
ffd988
cacaca
dac7b5
e9c49f
f6c08a
ffbd72
ffba5a
ffb73c
b5b6b5
c0ac9b
cea986
daa671
e3a35b
eca042
f39d1c
a3a2a2
a69281
b38e6e
be8b58
c78841
cf8524
888987
8b7768
987455
a3713f
ab6d27
6b6c6b
725d4e
7e5a3b
865728
8c540e
525251
584537
624226
693f11
3b3a3a
3f2e23
482b12
222221
2b190d
e9e8e7
f4e3ca
ffe1b0
ffdf98
ffdd7e
cacaca
d8c8b1
e4c69a
efc482
f8c168
ffbf4d
ffbd28
b5b6b5
bead97
caab80
d4a969
dca650
e3a433
a3a2a2
a3937e
ae9068
b88e50
c08c36
c68a10
888987
897865
94764f
9d7337
a4711b
6b6c6b
6f5f4c
7a5c36
815a21
525251
554636
5e4423
644108
3b3a3a
3d2f21
452d0d
222221
291a0a
e9e8e7
f1e5c7
fbe4ac
ffe292
ffe177
ffe05a
ffde34
cacaca
d6c9ae
dfc896
e8c77c
efc561
f6c442
fbc30a
b5b6b5
bbae95
c5ad7d
cdab63
d4aa48
d9a923
a3a2a2
a0947c
aa9264
b2914a
b88f2c
888987
867964
8f784b
977630
9c750d
6b6c6b
6c604a
755e33
7b5d1a
525251
524734
5a461f
3b3a3a
3a3020
412e07
222221
261b07
e9e8e7
eee6c5
f5e6a9
fbe68d
ffe670
ffe550
ffe51d
cacaca
d3caac
d9ca92
dfca77
e4ca5a
e9c936
b5b6b5
b8af94
beaf79
c5af5e
caae41
ceae0f
a3a2a2
9d957a
a49561
aa9445
af9323
888987
837b62
8a7a49
90792b
6b6c6b
696149
706031
745f15
525251
504834
55471e
3b3a3a
383120
3e3002
222221
241c07
e9e8e7
ece7c4
f0e8a8
f4e88c
f8e86d
fbe94c
fee90c
cacaca
d0cbac
d5cc91
d9cc75
dccd56
dfcd30
b5b6b5
b5b093
bab178
beb15d
c1b13d
a3a2a2
9b967a
9f9660
a39743
a6971d
888987
817c62
857c48
897c29
6b6c6b
676249
6b6230
6e6211
525251
4d4934
51491d
3b3a3a
363220
3a3200
222221
211d09
e9e8e7
e9e7c4
ece9a8
eeea8c
f0eb6c
f2ec4a
cacaca
ceccab
d0cd91
d2ce75
d4cf56
d6d02f
b5b6b5
b3b193
b5b279
b7b35d
b9b43d
a3a2a2
98977a
9a9861
9c9943
9e991d
888987
7e7c63
807e48
827e2a
6b6c6b
62634b
666430
676411
525251
4a4a35
4c4a1d
3b3a3a
333222
353304
222221
1e1e0c
e9e8e7
e6e8c5
e6eba9
e5ed8e
e4ee6f
e3f04e
e2f10d
cacaca
cbcdac
cacf93
c9d178
c8d35c
c7d435
b5b6b5
afb294
aeb47b
aeb662
adb743
acb90b
a3a2a2
94987c
949a63
939b48
929d24
888987
7a7d64
797f4c
788130
6b6c6b
60644c
5f6534
5e6717
525251
474a36
464c20
3b3a3a
303324
2f350c
222221
1b1e0f
e9e8e7
e3e9c6
e0ecac
dcef92
d8f276
d4f457
d0f629
cacaca
c7ceae
c4d097
c0d37e
bcd564
b8d844
b5b6b5
acb396
a8b67f
a4b868
a0ba4d
9cbc27
a3a2a2
91987e
8d9b67
899e50
84a032
888987
777e67
738151
6e8338
6a8517
6b6c6b
5d644e
596738
546920
525251
454b38
404d25
3b4f0b
3b3a3a
2e3426
293613
222221
191f12
e9e8e7
dbebcb
d2efb6
c9f39f
c0f688
b6fa6f
acfc53
a1ff2c
cacaca
c0cfb3
b7d39f
afd78b
a6da75
9cdd5e
92e03f
b5b6b5
a6b49b
9db888
95bb75
8cbe60
81c146
76c425
a3a2a2
8c9a81
839d70
7aa05d
70a346
65a62b
888987
727f6a
6a8259
608645
56882f
4a8b0a
6b6c6b
596552
4f6841
456b2e
3a6e13
525251
414c3c
384f2c
2d511b
3b3a3a
2b3428
22371a
153907
222221
161f15
062302
e9e8e7
d5ecd1
c8f1bf
b7f6ac
a9fa9c
98fe89
86ff78
6fff63
50ff4b
10ff29
cacaca
bbd0b7
aed5a8
a0d997
92dd88
81e076
6ee463
55e74f
2fea36
b5b6b5
a1b59f
95b98f
88bd81
79c171
67c460
51c84d
33ca37
a3a2a2
879a86
7b9e77
6da268
5da658
4aa948
2eac34
888987
6f806e
628460
548751
428b41
298e30
6b6c6b
566555
496948
386d39
227029
525251
3e4c3f
315033
205326
3b3a3a
29342a
1c3820
033a16
222221
141f17
e9e8e7
d0edd6
bef2ca
a7f8bc
91fcb1
76ffa6
54ff9b
cacaca
b7d1bd
a6d6b2
91dba6
7cdf9c
62e391
35e786
b5b6b5
9db6a3
8cba99
7abf8f
63c385
43c77a
a3a2a2
849b8a
72a080
5fa476
45a86d
14ab64
888987
6b8071
5a8568
45895f
228c56
6b6c6b
536659
406a50
246e48
525251
3c4c41
29503a
065433
3b3a3a
27352c
153826
222221
132018
e9e8e7
ceedda
b8f3d2
9cf9ca
7efec3
59ffbd
cacaca
b4d1c0
a0d6b9
87dcb2
6be0ab
43e4a6
b5b6b5
9bb6a7
87bba0
71bf99
54c494
19c88e
a3a2a2
829b8d
6ca086
55a480
31a87b
888987
698074
55856e
3b8968
6b6c6b
51665b
3b6b55
186f50
525251
3a4d43
24513e
3b3a3a
26352e
113829
222221
112019
e9e8e7
ccedde
b4f3d8
96f9d2
75fecd
48ffc9
cacaca
b3d1c3
9dd6be
82dcb9
64e0b5
2fe4b1
b5b6b5
9ab6a9
84bba4
6cbfa0
4ac49c
a3a2a2
819b8f
69a08a
4fa587
23a883
888987
688076
528572
34896e
6b6c6b
50665d
386b59
056f56
525251
394d45
205142
3b3a3a
25352f
0d382c
222221
10201b
e9e8e7
cbede0
b2f3dd
92f9d9
6cfed6
33ffd4
cacaca
b2d1c6
9bd7c2
7edcc0
5ce0bd
14e4bb
b5b6b5
99b6ac
82bba9
67c0a6
40c4a4
a3a2a2
809b92
66a08f
4aa58d
0ba98b
888987
678078
4f8576
2f8974
6b6c6b
4f665f
356b5d
525251
384d47
1b5145
3b3a3a
243530
07392f
222221
0f201c
e9e8e7
cbede3
b0f3e1
8ef9e0
64fedf
0fffdf
cacaca
b1d1c8
98d7c6
7cdbc6
55e0c5
b5b6b5
98b6ad
80bbad
64bfac
36c4ac
a3a2a2
7f9b94
64a093
46a593
888987
66807a
4d857a
2a897a
6b6c6b
4e6661
316b62
525251
374d49
17514a
3b3a3a
233532
003833
222221
0e201e
e9e8e7
cbede5
aef3e6
8bf9e8
5afee9
cacaca
b1d1cb
97d6cc
79dbcd
4be0d0
b5b6b5
97b6b0
7ebbb2
61bfb4
29c4b6
a3a2a2
7e9b97
63a099
3fa49b
888987
66807d
4b8580
228982
6b6c6b
4d6664
2f6b67
525251
364d4b
11514f
3b3a3a
223534
222221
0c2020
e9e8e7
cbece9
aef2ed
88f8f1
4ffdf6
cacaca
b2d0ce
97d6d1
75dbd6
45dfda
b5b6b5
98b5b3
7dbab7
5fbfbb
22c3c0
a3a2a2
7e9b99
62a09e
3da4a3
888987
658080
4b8484
1b8989
6b6c6b
4c6666
2e6a6b
525251
354d4d
0d5153
3b3a3a
223536
222221
0b2022
e9e8e7
cdeceb
aef2f2
87f7f9
cacaca
b3d0d0
97d5d6
76dadd
42dee4
b5b6b5
99b5b6
7ebabc
5fbec3
1dc2ca
a3a2a2
7f9a9b
649fa3
3ca3aa
888987
668082
4b8489
1a8891
6b6c6b
4d6668
2e6a70
525251
354c50
0d5058
3b3a3a
213538
222221
0a2024
e9e8e7
cfebed
b0f1f8
cacaca
b5cfd2
99d4db
78d9e4
45ddee
b5b6b5
9ab4b7
80b9c0
62bdc9
28c0d3
a3a2a2
809a9d
679ea6
40a2b0
888987
677f83
4d838d
208796
6b6c6b
4d656a
306974
525251
354c52
0e505c
3b3a3a
213439
222221
0a2025
e9e8e7
d2eaef
b4effd
cacaca
b8ced3
9ed3df
80d7eb
50dbf9
b5b6b5
9db3b9
85b7c4
68bbcf
3cbedb
a3a2a2
83999f
6c9da9
4ba0b6
888987
697f85
518290
2d859c
6b6c6b
4f656c
356877
525251
364c53
144f5f
3b3a3a
22343b
222221
0a1f27
e9e8e7
d6e9ef
baeeff
cacaca
bbcdd4
a4d1e1
89d5ef
60d8ff
b5b6b5
a0b3ba
8ab6c6
72b9d3
4fbce1
a3a2a2
8598a0
729bac
579eb9
2ea0c6
888987
6b7e86
578193
3b839f
6b6c6b
51646d
3c677a
186986
525251
374b55
1d4e62
3b3a3a
23343c
043648
222221
0c1f28
e9e8e7
d8e8f0
c0ecff
cacaca
beccd4
abcfe4
95d2f3
75d5ff
b5b6b5
a3b2ba
92b4c8
7eb7d6
63b9e4
35bbf4
a3a2a2
8897a0
789aad
639cbc
479ec9
888987
6e7d87
5d7f94
4881a1
2383af
6b6c6b
54636e
42657b
2a6788
525251
3a4b56
264c64
3b3a3a
25333e
0f354a
222221
0f1e2a
e9e8e7
dce7f0
cacaca
c1cbd5
b3cde5
a2cff5
b5b6b5
a6b1bb
99b2c9
8bb4d8
78b5e7
5eb7f8
a3a2a2
8b96a1
8098ae
7099bd
5f9acc
459bda
888987
717c88
657e95
557fa3
4180b1
1c81bf
6b6c6b
57626f
4a647c
3a6489
1c6597
525251
3d4a57
2f4b65
184b72
3b3a3a
28323f
19334b
222221
121e2a
e9e8e7
dfe6f0
cacaca
c4cbd5
bacce5
adccf7
b5b6b5
a9b0bb
a0b1c9
95b1d8
89b2e8
78b2f9
a3a2a2
8e95a1
8696af
7c96be
7097cd
6097db
4898eb
1798fb
888987
757b88
6c7c96
627ca4
557cb2
437dc0
267dce
6b6c6b
5b616f
52627d
47628a
376298
2062a5
525251
414958
384966
2a4973
15497f
3b3a3a
2b313f
22324c
113259
222221
161d2b
0b1d36
e9e8e7
e2e5f0
cacaca
c7cad5
c2c9e5
bcc9f6
b5b6b5
acafbb
a8aec9
a3aed9
9eade8
98abf9
a3a2a2
9294a1
8e94af
8a93be
8592cb
8091d9
798fe9
728ef9
888987
787a88
747a95
7079a4
6c77b1
6776be
6175cc
5a73da
5371e8
4d6df7
486aff
6b6c6b
5e6070
5b5f7d
575e8a
535d97
4d5ba4
485ab1
4457bd
4054ca
3e50d7
3d4ae5
3e46ee
3f3ffa
4137ff
525251
464758
424666
3e4573
3a437f
36418b
333e97
323aa3
3235af
332fb9
3529c2
381fcd
3b0ed7
3b3a3a
2f3040
2c2f4c
292d58
262b64
242870
25247a
261e84
29168d
2c0897
222221
1b1b2b
181a36
161741
17134b
190e54
1c055c
e9e8e7
e5e4ef
e3e3ff
cacaca
cac9d4
c9c8e3
c8c5f4
c7c3ff
b5b6b5
afaeba
aeadc9
aeabd7
ada9e5
ada6f5
ada3ff
a3a2a2
9594a1
9592ae
9490bc
948ec8
948cd5
9489e4
9586f2
9681ff
888987
7b7988
7b7894
7c75a2
7c73af
7c70ba
7d6dc7
7e6ad4
7f66e0
8162eb
835df7
8756ff
6b6c6b
625f70
625d7c
635b88
645894
6456a0
6652ac
674eb7
6a49c1
6d43cc
713cd8
7434e0
782aea
7c17f4
525251
4a4658
4a4465
4c4170
4d3e7b
4f3a87
513691
54309c
5828a6
5b1faf
5f10b8
3b3a3a
332f3f
342d4b
362a55
382660
3a216a
3d1b73
41127c
222221
1f1a2b
211735
23143e
250f46
29064f
e9e8e7
e7e4ef
e9e1ff
cacaca
ccc9d3
cec6e2
d1c3f0
d4c0ff
b5b6b5
b1aeba
b4abc7
b7a8d3
baa5e0
bea1ee
c29dfb
a3a2a2
9793a0
9a90ac
9d8eb9
a18ac5
a487d1
a983dc
ad7ee8
b379f4
b773fe
888987
7e7987
817693
84739f
886fab
8c6cb5
9068c0
9563ca
995dd4
9e57de
a350e9
a847f3
ad3bfe
b32cff
6b6c6b
655e6f
685b7a
6c5985
70558f
74519a
784ca4
7d46ae
823fb7
8737c1
8c2bcb
901ed3
525251
4d4557
514263
553e6d
593a77
5e3481
622e8a
672693
6c1a9c
7104a5
3b3a3a
362e3e
392b48
3d2851
42225b
471c64
4c126c
222221
22192a
261533
2a113a
2e0942
e9e8e7
e8e4ee
eee0fd
cacaca
cdc8d2
d3c5df
d8c1ec
dfbdf9
e5b8ff
b5b6b5
b4adb9
b9aac4
bea6cf
c4a3db
ca9ee7
d099f2
d794fd
a3a2a2
9a929f
9f8faa
a58bb5
aa88bf
b083ca
b67fd4
bc79df
c273e9
c86cf3
cf64fe
888987
807885
867590
8c719b
926da5
9768af
9d63b9
a35dc2
a957cb
af4fd4
b546dd
bb39e7
c228f0
c801f9
6b6c6b
685e6d
6d5a78
735681
78528a
7e4d94
84479d
8a40a6
9037af
962cb8
9c1ac1
525251
504456
564060
5b3c69
613772
67307b
6d2884
731d8c
790894
3b3a3a
382e3d
3e2a46
42264d
491f57
4e175f
540967
222221
241829
291431
2e0e38
33043f
e9e8e7
ece3eb
f8def6
ffd8ff
cacaca
d0c7d0
dbc3d9
e3bfe2
eeb8ed
f8b3f7
ffacff
b5b6b5
b7acb6
c0a8bf
c8a4c8
d19fd1
da99db
e293e3
eb8ced
f485f6
fd7cff
a3a2a2
9d919d
a58ea5
ae89af
b684b7
be7fc0
c679c8
ce72d1
d66bd9
dd62e2
e656ec
ef47f5
f734fe
888987
837783
8b738c
946e95
9c699e
a364a6
aa5dae
b256b6
b94ebe
c043c7
c836cf
d020d8
6b6c6b
6b5d6b
725974
7a547c
814f84
88498c
8f4294
96399c
9e2ca5
a51aad
525251
534454
5a3f5c
613a64
69336d
6f2c75
76217d
7d0f85
3b3a3a
3a2d3c
412943
47244a
4e1c53
54125a
222221
261828
2c132f
310c35
e9e8e7
ede3e9
fcddf1
ffd7f9
cacaca
d2c7ce
dec2d5
eabddd
f7b6e5
ffb0ec
ffa9f4
ffa0fd
b5b6b5
b9acb4
c4a7bb
cfa2c2
da9cc9
e496d1
ed90d7
f888df
ff7ee7
ff74ee
ff68f6
ff58ff
a3a2a2
9f919b
a98da2
b487a9
bd82af
c77cb6
d075bd
da6cc4
e364cb
eb5ad2
f54bda
fe39e1
ff1de8
888987
857781
8f7288
9a6d8f
a46696
ac609d
b559a4
bd50aa
c646b1
ce39b8
d724bf
6b6c6b
6d5c69
775770
805277
884c7d
904584
983d8b
a03291
a82398
525251
554351
5e3e59
663860
6f3067
76276e
7f1875
3b3a3a
3c2d3a
432841
4a2347
521a4e
590d55
222221
271727
2e122d
330b33
e9e8e7
efe2e8
ffdcec
ffd5f1
cacaca
d3c7cc
e2c1d1
f1bbd5
ffb4da
ffaddf
ffa4e4
ff9bea
b5b6b5
baacb2
c7a6b6
d5a0bb
e19ac0
ec93c4
f88cca
ff83ce
ff78d4
ff6bda
ff5be0
a3a2a2
a19199
ad8c9d
b986a2
c480a6
cf79ab
da71b0
e568b5
ef5dba
f951bf
ff3fc4
ff29c9
888987
87777f
937184
9f6b89
ab648e
b45d92
be5497
c84a9c
d13ea1
da2ca6
e307ab
6b6c6b
6f5c66
7a576b
855070
8f4975
98417a
a1377f
aa2a84
b31489
525251
57434e
623d54
6b3659
752d5e
7e2263
870e69
3b3a3a
3e2c38
46273d
4e2142
571648
5f034d
222221
291726
30112b
360931
e9e8e7
f0e2e6
ffdbe7
ffd4e8
cacaca
d5c7cb
e5c1cb
f6bacd
ffb2ce
ffabd0
ffa0d2
b5b6b5
bcabb0
caa6b1
da9fb3
e898b4
f491b6
ff88b8
ff7eba
ff72bd
ff64c0
a3a2a2
a39096
b08b97
bf8499
cb7e9b
d6779c
e26e9f
ee64a1
f958a4
ff49a6
ff2faa
ff04ac
888987
89767c
97707e
a46a80
b16282
bc5a84
c75087
d24489
dc358c
e61c8e
6b6c6b
715c63
7d5665
8a4f68
95476a
9e3f6d
a93270
b22273
525251
58424b
653c4e
703451
7a2b55
841d58
3b3a3a
402c36
492639
51203d
5b1442
222221
2a1624
321028
38072d
e9e8e7
f1e2e4
ffdbe2
ffd3e1
cacaca
d6c6c9
e8c0c7
f9b9c6
ffb1c6
ffa9c5
ff9fc5
b5b6b5
bdabae
cca6ad
dc9fac
eb98ac
f890ab
ff87ab
ff7cab
ff6fac
a3a2a2
a39094
b28b93
c28492
ce7e92
db7692
e76d92
f36293
ff5493
ff4494
ff2896
888987
8a767a
997079
a76979
b46179
c05979
cc4d7a
d6427b
e1307c
eb117d
6b6c6b
725b61
805561
8d4e61
994661
a33d62
ad3063
b81c64
525251
5a4249
673b4a
72344b
7e294c
881a4e
3b3a3a
402c34
4a2636
531f39
5d123c
222221
2b1622
330f26
3b0429
e9e8e7
f2e2e3
ffdbde
ffd3d9
cacaca
d7c6c8
eac0c3
fbb9c0
ffb1bc
ffa9b8
b5b6b5
beabac
cea5a9
de9fa6
ee97a2
fc909f
ff859c
ff7b9a
ff6e97
a3a2a2
a49092
b48a8f
c4848c
d07d89
de7587
eb6b84
f76183
ff5280
ff417f
888987
8b7678
9b7075
a96973
b76170
c3586e
d04c6d
da406c
e62d6a
6b6c6b
735b5f
81555c
8e4e5a
9b4559
a63b58
b12d57
bc1756
525251
5b4246
683b45
743343
802843
8b1742
3b3a3a
412c32
4c2533
551e34
*/
`5f1036
222221
2c1620
350f23
dddddd
000000
222222
444444
888888
aaaaaa
cccccc
59a102
3c0325
ff406c
f4083d
f0201e
ff6114
ee710a
ffae2b
f39d1c
ffbd28
fbc30a
ffe51d
fee90c
d6d02f
e2f10d
d0f629
a1ff2c
10ff29
35e786
43e4a6
2fe4b1
14e4bb
0fffdf
4be0d0
45dfda
1dc2ca
28c0d3
3cbedb
4fbce1
35bbf4
459bda
1798fb
4137ff
7c17f4
b32cff
c801f9
f734fe
ff1de8
ff29c9
ff04ac
ff2896
ff417f`;

const munselColors = mText; //.split('\n');
export default munselColors;